import gql from 'graphql-tag';
import client from '../../client';
export const PREVIEW_CANCEL_MEMBERSHIP = gql `
  mutation PreviewCancelMembership($input: PreviewCancelMembershipInput!) {
    previewCancelMembership(input: $input)
    @rest(type: "PreviewCancelMembership", path: "admin/orders/preview-cancel", method: "POST") {
      data {
        amount
        currency
        refundType
      }
    }
  }
`;
// Mutation to preview cancel membership details
export const previewCancelMembership = (membershipId, orderId, userId) => {
    return client.mutate({
        mutation: PREVIEW_CANCEL_MEMBERSHIP, variables: {
            input: {
                userId,
                data: {
                    membershipId,
                    orderId,
                    type: 'hdcMembershipCancellation',
                },
            },
        },
    });
};
export default previewCancelMembership;
